export default {
  root: {
    fontSize: "2.4rem"
  }
};
